import ForgotPasswordCard from "../../components/auth/ForgotPasswordCard";

export default function ForgotPassword() {
  return <ForgotPasswordCard />;
}
